import { Link } from "react-router-dom";
import { useLang } from "../lang";

function Error() {
  const { t } = useLang();
  return (
    <section className="wrap py-24 text-center">
      <p className="text-7xl font-bold text-steel-400">404</p>
      <h1 className="mt-4 text-2xl font-bold">{t("ไม่พบหน้านี้", "Page not found")}</h1>
      <Link to="/" className="btn-primary mt-8">{t("กลับหน้าแรก", "Back to home")}</Link>
    </section>
  );
}

export default Error;
